/*!
 * vue-tag v0.10.6 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
var Tag = {
  name: 'tag',
  functional: true,
  props: {
    tag: {
      default: 'div'
    }
  },
  render: function render(h, context) {
    return h(context.props.tag, context.data, context.children);
  }
};

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? Tag.name : _ref$name;

  Vue.component(name, Tag);
}
var main = {
  install: install
};

export default main;
export { Tag, install };
